'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const TimelineGridBodyRowContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") TimelineGridBodyRowContext.displayName = "TimelineGridBodyRowContext";
export function useTimelineGridBodyRowContext() {
  const context = React.useContext(TimelineGridBodyRowContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: <TimelineGrid.TitleRow /> and <TimelineGrid.EventRow /> must be rendered inside a <TimelineGrid.BodyRow />.' : _formatErrorMessage(280));
  }
  return context;
}